import { createAsyncThunk, createSelector, createSlice, isAnyOf } from "@reduxjs/toolkit";

import apiUserAdv from "api/user_adv";
import { USER_SETTINGS_KEY } from "core/local_storage_utils";
import { parseJsonString } from "core/str_utils";
import { setFetchStatus, setFetchStatusText } from "slices/project_work";

export const getUserSettings = createAsyncThunk("userAdvSlice/getUserSettings", async () => {
	const response = await apiUserAdv.getUserSettings();
	return response.data;
});

export const getUserUnreadTasks = createAsyncThunk("userAdvSlice/getUserUnreadTasks", async () => {
	const response = await apiUserAdv.getUserTasks();
	return response.data;
});

export const getUserTasks = createAsyncThunk("userAdvSlice/getUserTasks", async () => {
	const response = await apiUserAdv.getUserTasks();
	return response.data;
});

export const getUserTasksAndRead = createAsyncThunk("userAdvSlice/getUserTasksAndRead", async () => {
	const response = await apiUserAdv.getUserTasksAndRead();
	return response.data;
});

export const getTaskExtraInfo = createAsyncThunk("userAdvSlice/getTaskExtraInfo", async ({ taskId }) => {
	const response = await apiUserAdv.getTaskExtraInfo({ taskId });
	return response.data;
});

export const postUserComplaint = createAsyncThunk("userAdvSlice/postUserComplaint", async ({ body }, { dispatch }) => {
	const response = await apiUserAdv.postUserComplaint({ body });
	dispatch(setFetchStatus("successAlert"));
	dispatch(setFetchStatusText("Ваше обращение принято. Спасибо за обратную связь!"));
	return response.data;
});

const initialState = () => {
	const userSettings = parseJsonString(localStorage.getItem(USER_SETTINGS_KEY));

	return {
		settings: {},
		userTasks: [],
		userTasksVisible: false,
		unreadTasks: 0,
		userSettingsChangedCount: 0,
		userSettings: userSettings ?? {},
		timeoutId: null,
		userSettingsVisible: false,
	};
};

export const userAdvSlice = createSlice({
	name: "userAdvSlice",
	initialState,
	reducers: {
		setSettings: (state, { payload }) => {
			state.settings = { ...state.settings, ...payload };
		},
		setUserTasks: (state, { payload }) => {
			state.userTasks = payload;
		},
		setUserTasksVisible: (state, { payload }) => {
			state.userTasksVisible = payload;
		},
		setUserSettingsVisible: (state, { payload }) => {
			state.userSettingsVisible = payload;
		},
		setParamUserSettings: (state, { payload }) => {
			const { param, key, value } = payload;
			if (key) {
				state.settings[param][key] = value;
			} else {
				state.settings[param] = value;
			}
			state.userSettingsChangedCount += 1;
		},
		setUserSettings: (state, { payload }) => {
			state.userSettings = payload;
			clearTimeout(state.timeoutId);
			state.timeoutId = setTimeout(() => localStorage.setItem(USER_SETTINGS_KEY, JSON.stringify(payload)), 1000);
		},
	},
	extraReducers: (builder) => {
		builder.addMatcher(isAnyOf(getUserSettings.fulfilled), (state, { payload }) => {
			state.settings = { ...state.settings, ...payload };
		});
		builder.addMatcher(isAnyOf(getUserTasks.fulfilled), (state, { payload }) => {
			state.userTasks = payload;
			state.unreadTasks = payload?.filter((x) => x?.is_viewed === false)?.length;
		});
		builder.addMatcher(isAnyOf(getUserUnreadTasks.fulfilled), (state, { payload }) => {
			// state.userTasks = payload; // Вызвало ненужные ререндеры
			state.unreadTasks = payload?.filter((x) => x?.is_viewed === false)?.length;
		});
		builder.addMatcher(isAnyOf(getUserTasksAndRead.fulfilled), (state, { payload }) => {
			state.userTasks = payload;
			state.unreadTasks = 0;
		});

		builder.addMatcher(isAnyOf(getUserSettings.pending, getUserTasks.pending, getUserTasksAndRead.pending), (state, action) => {});

		builder.addMatcher(isAnyOf(getUserSettings.rejected, getUserTasks.rejected, getUserTasksAndRead.rejected), (state, { payload }) => {
			console.error(payload);
		});
	},
});

export const { setSettings, setUserTasks, setUserTasksVisible, setParamUserSettings } = userAdvSlice.actions;

export default userAdvSlice.reducer;

export const userAdvActions = userAdvSlice.actions;

export const getStorageUserSettings = (state) => state.userAdv.userSettings;
export const getUserSettingsVisible = (state) => state.userAdv.userSettingsVisible;
export const getUserStateTasks = (state) => state.userAdv.userTasks;
export const getUserSettingsProjectTreeLsrStatus = (state) => state.userAdv.userSettings;

export const getLastProjectSearchTask = createSelector([getUserStateTasks], (tasks) => {
	const fltTasks = tasks.filter((task) => task.task_type_en === "ADV_PROJECT_SEARCH");
	if (fltTasks?.length > 0) {
		return fltTasks[0];
	} else {
		return null;
	}
});

export const getUserSettingsLsrStatus = createSelector([getStorageUserSettings], (setting) => {
	return setting?.projectTree?.lsrStatusUsage;
});

export const getUnionUserSettings = (state) => ({ ...state.userAdv.settings, ...state.userAdv.userSettings });
